import styled from "@emotion/styled";

import { theme } from "../../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const StepLinks = styled.div({
    paddingTop: 10,
});

interface StepLinkProps {
    previous?: boolean;
    disabled: boolean;
}

export const StepLink = styled.a<StepLinkProps>(
    props => ({
        fontSize: theme(props).typography.smallFont.fontSize.css(),
        lineHeight: theme(props).typography.smallFont.lineHeight.css(),
        color: theme(props).typography.primary.color,
        cursor: props.disabled ? "default" : "pointer",

        ":hover": {
            textDecoration: "underline",
        },
    }),
    props => props.previous && { marginRight: 10 },
    props =>
        props.disabled && {
            color: theme(props).typography.inactive.color,
            pointerEvents: "none",
        }
);

export const PagingWrapper = styled.div(props => ({
    paddingTop: theme(props).size(1),
}));

export const Description = styled.div(props => ({
    color: theme(props).typography.secondary.color,
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: "16px",
    paddingTop: 5,
}));
